/* eslint-disable no-unused-vars */
import Choices from 'choices.js';
import { Component } from '../core/component';

export class Wayfinder extends Component {
    constructor() {
        super();
        this.selector = '[data-wayfinderselect]';
    }

    init() {
        const dropdowns = document.querySelectorAll('[data-choices]');
        const panels = document.querySelectorAll('[data-wayfinder-panel]');

        function showPanel(id) {
            panels.forEach((panel) => {
                panel.setAttribute('aria-hidden', panel.id === id ? 'false' : 'true');
            });
        }

        dropdowns.forEach((dropdown) => {
            const choice = new Choices(dropdown, {
                removeItemButton: false,
                shouldSort: false,
                searchFloor: 2,
                searchFields: ['label', 'value'],
                searchEnabled: false,
                maxItemCount: 1,
                classNames: {
                    containerOuter: 'choices choices--wayfinder',
                },
            });

            dropdown.addEventListener(
                'choice',
                (event) => {
                    choice.hideDropdown();
                },
                false,
            );

            choice.passedElement.element.addEventListener('addItem', (event) => {
                showPanel(event.detail.value);
            });
        });
    }
}
